import React, {useState, useEffect, useContext} from 'react';
import Article from './Article';
import {sortObjects, sortObjectsByNumber} from 'Helpers/sortObjects';
import moment from 'moment';
import {numberWithCommas} from 'utils/other';
import {Input} from 'reactstrap';
import SocialFilters from './SocialFilters';

const ArticleList = (props) => {
    const {
        searchResults, activeSort, socialFilters, sentimentFilters,
        heightForVirtualization, end, listType, periodFilter, activeEntitiesForSavedSearch,
        sentimentCount, setSentimentCount, setSocialCount, updatingCount, setUpdatingCount,
        handleEntitySortChange, totalCount,
    } = props;
    const [filteredResults, setFilteredResults] = useState([]);

    useEffect(() => {
        // if(searchResults && searchResults.length > 0) {
        if(searchResults !== null) {
            // let filteredBySentimentList = filterBySentiment(searchResults);
            // let entityFilteredList = filterByEntity(filteredBySentimentList);
            // let dateFilteredList = filterSearchResultsByPeriod(entityFilteredList);
            // sortSearchResults(dateFilteredList);
            sortSearchResults(searchResults);

        }
    }, [activeSort, searchResults]);

    // const filterByEntity = (arr) => {
    //     return arr.filter(item => {
    //         return activeEntitiesForSavedSearch.includes(item.entityId || item.entity_id);
    //     });
    // };

    const filterBySentiment = (arr) => {
        let allowedSentiments = [];
        sentimentFilters.negative && allowedSentiments.push(-1);
        sentimentFilters.neutral && allowedSentiments.push(0);
        sentimentFilters.positive && allowedSentiments.push(1);
        return arr.filter(item => {
            return allowedSentiments.includes(item.sentiment);
        });
    };

    const filterBySource = (arr) => {
        let allowedSources = [];
        for(const property in socialFilters) {
            if(socialFilters.hasOwnProperty(property) && socialFilters[property]) {
                allowedSources.push(property);
            }
        }
        // console.log(allowedSources)
        let newArr = arr.filter(item => {
                if(item.type) {
                    return (allowedSources.includes(item.type) || (item.type === 'google_ozmosys' && allowedSources.includes('rss')));
                } else {
                    // console.log(item)
                    // console.log(allowedSources.includes(item.sourceType))
                    // console.log(item.sourceType === 'google_ozmosys' && allowedSources.includes('rss'))
                    return (allowedSources.includes(item.sourceType) || (item.sourceType === 'google_ozmosys' && allowedSources.includes('rss')));
                }
            });
        // console.log(newArr)
        return newArr;
    };

    const filterSearchResultsByPeriod = (arr) => {
        const periodStart = moment().subtract(periodFilter, 'days').startOf('day');
        let newArr = [...arr].filter(item => {
            return item.hasOwnProperty('published') ? moment(item.published).isAfter(periodStart) : moment(item.publishedAt).isAfter(periodStart);
        });
        // setFilteredSearchResults(newArr);
        return newArr;
    };

    const sortSearchResults = (arr) => {
        let newArr = [...arr];
        let sortedResults;
        let numSortValue = parseInt(activeSort);
        let dateString = arr.length > 0 && arr[0].hasOwnProperty('publishedAt') ? 'publishedAt' : 'published';
        switch(numSortValue) {
            case 0:
                sortedResults = sortObjects(newArr, dateString, 'desc');
                break;
            case 1:
                sortedResults = sortObjects(newArr, dateString, 'asc');
                break;
            case 2:
                sortedResults = sortObjectsByNumber(newArr, 'influence', 'desc');
                break;
            case 3:
                sortedResults = sortObjectsByNumber(newArr, 'influence', 'asc');
                break;
            default:
                sortedResults = sortObjects(newArr, 'published', 'desc');
                break;
        }
        // getSocialCount(sortedResults);
        setFilteredResults(sortedResults);
    };

    return (
        <>
            {searchResults !== null && totalCount !== null &&
            <>
                <div className="mt-3">
                    {totalCount > 0 ? totalCount : 'No'} {totalCount === 1 ? 'result' : 'results'} found
                    {/*{` ${filteredResults.length === 0 ? 'No' : numberWithCommas(filteredResults.length)} */}
                    {/*${filteredResults.length === 1 ? 'post' : 'posts'} matched your filters in the `}*/}
                    {/*{periodFilter !== null ?*/}
                    {/*    <>{periodFilter === 0 ? `past 1 day.` :*/}
                    {/*        `past ${periodFilter === 31 ? '30+' : periodFilter} ${periodFilter === 1 ? 'day.' : 'days.'}`*/}
                    {/*    }*/}
                    {/*    </>*/}
                    {/*    :*/}
                    {/*    <>{`past ${periodFilter === 31 ? '30+' : periodFilter} ${periodFilter === 1 ? 'day.' : 'days.'}`}</>*/}
                    {/*}*/}
                </div>
            </>
            }
            <div className="home-page-article-list">
                <div style={{heightForVirtualization}}>
                    <div>
                        {filteredResults && filteredResults.slice(0, end).map(item =>
                            <Article viewTy article={item} key={item.type ? `${item.type}-${item.id}` :
                                item.sourceType ? `${item.type}-${item.id}` : item.id}/>,
                        )}
                    </div>
                </div>
            </div>
        </>
    );
};

export default ArticleList;